<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        :auto-size-cell="true"
        :row-multi-select-with-click="true"
        class="agGrid"
        @selectionChanged="selectionChanged"
      />
    </div>
    <div class="button-containers">
      <button
        :disabled="isDisableDelete"
        class="btn primary small outline"
        @click="deleteVIP"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="isDisableModify"
        class="btn primary small"
        @click="updateVipView"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="addView">
        {{ $t('button.add') }}
      </button>
    </div>
    <el-dialog
      :title="!isEdit ? 'Thêm VIP' : 'Sửa VIP'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Mã VIP</div>
                  <validation-provider
                    rules="required|positiveNum|max:20"
                    name="Mã VIP"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="form.code"
                        :disabled="isEdit"
                        type="text"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">Mô tả</div>
                  <validation-provider
                    rules="required|max:100"
                    name="Mô tả VIP"
                  >
                    <textarea
                      v-model="form.desc"
                      style="width: 100%"
                      rows="4"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small outline"
            @click="updateVIP"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small outline" @click="addVIP">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import {
  getVIPListApi,
  addCodeApi,
  updateCodeApi,
  deleteCodeApi
} from '@/api/common/code'
import { Message } from 'element-ui'
export default {
  data() {
    return {
      isDisableModify: false,
      isDisableDelete: false,
      loading: false,
      defaultForm: {
        id: null,
        p_code: 'VIP',
        code: '',
        desc: ''
      },
      form: {
        id: null,
        p_code: 'VIP',
        code: '',
        desc: ''
      },
      titlePopup: 'Thêm VIP',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        pageSize: 10,
        pageNum: 1,
        orderTp: 'ASC'
      },
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
          // cellStyle: {'padding-left': '12px'}
        },
        {
          headerName: 'Mã VIP',
          sortable: false,
          field: 'code',
          width: 100
        },
        {
          sortable: false,
          headerName: 'Mô tả',
          field: 'desc'
          // cellRenderer: 'CellRenderTextInput',
        }
      ],
      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetItemInfo()
    }
  },

  mounted() {
    this.attachData()
  },
  methods: {
    selectionChanged(rows) {
      if (rows.length == 0) {
        this.isDisableModify = true
        this.isDisableDelete = true
      } else if (rows.length > 1) {
        this.isDisableModify = true
      } else {
        this.isDisableModify = false
        this.isDisableDelete = false
      }
    },
    async attachData() {
      // bus.$emit('startLoader', { msg: '' })
      this.loading = true
      let data = await getVIPListApi()
      // bus.$emit('endLoader')
      this.loading = false
      this.rows = data.data
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      this.currentPage = data.data.length == 0 ? 0 : data.page_num
    },
    async addVIP() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      await addCodeApi(this.form)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async updateVIP() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      await updateCodeApi(this.form)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },

    async deleteVIP() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.$vxConfirm(this.$t('alert.deleteVipConfirm'), async () => {
          await deleteCodeApi({
            ids: id_list
          })
            .then(async res => {
              const message = res.message
              await this.attachData()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },
    addView() {
      this.dialogFormVisible = true
      this.isEdit = false
    },
    updateVipView() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected.length == 0 || rowsSelected.length > 1) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.titlePopup = 'Sửa VIP'
        this.isEdit = true
        const rowData = rowsSelected[0]
        this.form.code = rowData.code
        this.form.desc = rowData.desc
        this.form.id = rowData.id
        this.dialogFormVisible = true
      }
    },
    resetItemInfo() {
      this.form = { ...this.defaultForm }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
